import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { meta } from "./../../meta"

@Injectable({
	providedIn: 'root'
})
export class MetaService {

	constructor(private titleService: Title, private metaService: Meta, @Inject(DOCUMENT) private dom) { }

	setMeta(name, content) {
		if (!!content) {
			this.metaService.updateTag({name: name, content: content})
		} else {
			this.metaService.removeTag('name='+name)
		}
	}

	apply(page: string) {

		if (page in meta) {
			let item = meta[page]
			this.titleService.setTitle("title" in item ? item.title : "Rent-A-Store")
			this.setMeta('keywords', item.keywords)
			this.setMeta('description', item.description)
			this.setMeta('robots', item.robots)

			var link: HTMLLinkElement = this.dom.head.querySelector(`link[rel='canonical']`) || null
			if ('canonical' in item) {
				if (link == null) {
					link = this.dom.createElement('link') as HTMLLinkElement;
					this.dom.head.appendChild(link);
				}
				link.setAttribute('rel', 'canonical')
				link.setAttribute('href', item.canonical)
			} else {
				if (link) this.dom.head.removeChild(link)
			}
		}
	}
}
